module.exports = __webpack_public_path__ + "img/KC_BG0.94e75a98.png";